
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path-1",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M12 17.33c-.74 0-1.33-.45-1.33-1a.34.34 0 00-.33-.33.34.34 0 00-.34.33c0 .82.72 1.51 1.66 1.64v.7A.34.34 0 0012 19a.33.33 0 00.34-.34v-.69c.94-.13 1.66-.82 1.66-1.64s-.64-1.36-1.92-1.65c-.42-.1-1.4-.39-1.4-1.01 0-.55.58-1 1.32-1 .74 0 1.33.45 1.33 1a.34.34 0 00.57.24.33.33 0 00.1-.24c0-.82-.72-1.51-1.66-1.64v-.7A.34.34 0 0012 11a.34.34 0 00-.34.34v.69c-.94.13-1.66.82-1.66 1.64 0 .78.69 1.38 1.92 1.65.93.23 1.4.56 1.4 1.01.02.55-.58 1-1.32 1z","clip-rule":"evenodd"}}),_c('path',{staticClass:"path-2",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M3 17c0 4.14 4.68 5 8.61 5 6.06 0 9.39-1.77 9.39-5 0-3.04-2.82-7.06-5.96-8.77.12-.08.23-.19.3-.3a1 1 0 00.15-.8c-.04-.14-.1-.27-.19-.38-.13-.17-.32-.3-.53-.38.27-1.85 2.92-3.68 2.96-3.72a.37.37 0 00.1-.1.33.33 0 00.04-.27.34.34 0 00-.07-.13.42.42 0 00-.2-.12.45.45 0 00-.25 0c-.02 0-1.9.69-3.37.69-.45 0-1.33-.17-2.2-.34C10.81 2.18 9.87 2 9.3 2c-2.46 0-3 .75-3.08.9a.3.3 0 00-.02.28c.03.09.1.16.19.2.01.03 2.61 1.23 2.87 2.98-.14.04-.27.12-.38.21a.98.98 0 00-.3 1.14c.06.2.2.38.4.5C5.8 9.96 3 13.97 3 17zm6.64-9.27c-.1 0-.2-.04-.28-.1a.35.35 0 01-.09-.4.35.35 0 01.09-.12.42.42 0 01.28-.1h4.7c.1 0 .2.04.28.1a.35.35 0 01.09.4.35.35 0 01-.09.12.42.42 0 01-.28.1h-4.7zM7.19 3.05c.34-.14.94-.31 2.05-.31.51 0 1.43.19 2.34.36.94.19 1.84.36 2.37.36.65-.02 1.3-.1 1.93-.24-.82.79-1.75 1.92-1.91 3.1h-3.95c-.25-1.61-1.94-2.78-2.83-3.27zm3.01 5.4h3.6c3.25 1.23 6.4 5.45 6.4 8.55 0 3.72-5.4 4.29-8.61 4.29-5.2 0-7.83-1.44-7.83-4.3 0-3.1 3.18-7.32 6.43-8.55z","clip-rule":"evenodd"}})])
          )
        }
      }
    